import { css } from '@emotion/core'
import { colors } from '@dw/helix'

export const panelStyles = css`
  background-color: #fff;
  padding: 12px 15px;
  border-radius: 2px;
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.19), 0 3px 3px 0 rgba(0, 0, 0, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  min-height: 250px;
`

export const numberOfResultsStyles = css`
  display: flex;
  margin-top: 30px;
`

export const infoRowStyles = css`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 41px;
  button:not(:first-of-type) {
    margin-left: 20px;
  }
`
export const placeRightStyles = css`
  margin-left: auto;
`

export const noSearchResultsStyles = css`
  width: 100%;
  height: 141px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.grey3};
`
